import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container page-container" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_3 = { class: "alert-body" }
const _hoisted_4 = { class: "alert-heading" }
const _hoisted_5 = { class: "alert-text" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_7 = {
  key: 1,
  class: "alert alert-warning",
  "aria-role": "alert",
  "aria-atomic": "true"
}
const _hoisted_8 = { class: "alert-body" }
const _hoisted_9 = { class: "alert-heading" }
const _hoisted_10 = { class: "alert-text" }
const _hoisted_11 = {
  key: 2,
  class: "alert alert-warning",
  "aria-role": "alert",
  "aria-atomic": "true"
}
const _hoisted_12 = { class: "alert-body" }
const _hoisted_13 = { class: "alert-heading" }
const _hoisted_14 = { class: "alert-text" }
const _hoisted_15 = {
  key: 3,
  class: "alert alert-error",
  "aria-role": "alert",
  "aria-atomic": "true"
}
const _hoisted_16 = { class: "alert-body" }
const _hoisted_17 = { class: "alert-heading" }
const _hoisted_18 = { class: "alert-text" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_20 = {
  style: {"margin-top":"0"},
  id: "blanketOverskrift"
}
const _hoisted_21 = {
  key: 4,
  class: "font-lead"
}
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_klarTekst = _resolveComponent("klarTekst")!
  const _component_Opsummering = _resolveComponent("Opsummering")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.isPublished)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.publiceret-titel' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("p", _hoisted_5, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.publiceret-beskrivelse' }, null, 8, ["tekstNoegle"]),
              _hoisted_6,
              _createVNode(_component_router_link, {
                to: '/blanket/opsummering/' + _ctx.blanketId
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.publiceret-beskrivelse-link-titel' }, null, 8, ["tekstNoegle"])
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.isDraft && !this.isPublishedDraft && !this.isClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.kladde-titel' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("p", _hoisted_10, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.kladde-beskrivelse' }, null, 8, ["tekstNoegle"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.isPublishedDraft && !this.isPublished && !this.isClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.publiceret.kladde-titel' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("p", _hoisted_14, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.publiceret.kladde-beskrivelse' }, null, 8, ["tekstNoegle"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.isClosed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.afsluttet-titel' }, null, 8, ["tekstNoegle"])
            ]),
            _createElementVNode("p", _hoisted_18, [
              _createVNode(_component_klarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.afsluttet-beskrivelse' }, null, 8, ["tekstNoegle"]),
              _hoisted_19,
              _createVNode(_component_router_link, { to: '/overblikOG' }, {
                default: _withCtx(() => [
                  _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.og-opsummering.alerts.afsluttet-beskrivelse-link-titel' }, null, 8, ["tekstNoegle"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.overskrift), 1),
    (_ctx.underoverskrift)
      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.underoverskrift), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", { innerHTML: _ctx.beskrivelse }, null, 8, _hoisted_22),
    _createVNode(_component_Opsummering, {
      formular: this.formular,
      editable: false
    }, null, 8, ["formular"])
  ]))
}